import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "rounded-lg border-0 mx-4 my-4 relative"
};
import { onMounted, reactive, ref, computed } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { useMaxioSubscriptionStore } from "./useMaxioSubscriptionStore.js";
export default {
  __name: 'VerifyBankAccountModel',
  props: {
    alerts: {
      type: Object,
      required: false
    }
  },
  emits: ["cancel"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const firstAmountInput = ref(null);
    const verifyBankAccountState = reactive({
      loading: false,
      firstAmount: "$0.",
      secondAmount: "$0.",
      dialog: true
    });
    const emit = __emit;
    const maxioCompanySubscriptionStore = useMaxioSubscriptionStore();
    maxioCompanySubscriptionStore.alerts = props.alerts;
    onMounted(() => {
      firstAmountInput.value.focus();
    });
    const isVerifyButtonDisabled = computed(() => {
      const isValidAmount = amount => {
        const regex = /^\$\d+\.\d{2}$/;
        return regex.test(amount);
      };
      return !isValidAmount(verifyBankAccountState.firstAmount) || !isValidAmount(verifyBankAccountState.secondAmount);
    });
    const handleInput = (event, field) => {
      let value = event.target.value.replace(/[^0-9.]/g, "");
      if (!value.includes(".")) {
        value = "0." + value;
      }
      let [dollars, cents] = value.split(".");
      cents = cents ? cents.slice(0, 2) : "";
      const finalValue = `$${dollars}.${cents}`;
      if (field === "firstAmount") {
        verifyBankAccountState.firstAmount = finalValue;
      } else if (field === "secondAmount") {
        verifyBankAccountState.secondAmount = finalValue;
      }
      event.target.value = finalValue;
    };
    const verifyAccount = async () => {
      const extractCents = amount => amount.split(".")[1];
      const firstAmountCents = extractCents(verifyBankAccountState.firstAmount);
      const secondAmountCents = extractCents(verifyBankAccountState.secondAmount);
      verifyBankAccountState.loading = true;
      const verified = await maxioCompanySubscriptionStore.verifyBankAccount(firstAmountCents, secondAmountCents);
      if (verified) {
        props.alerts?.success("Bank account verified successfully");
        verifyBankAccountState.loading = false;
        verifyBankAccountState.dialog = false;
      } else {
        verifyBankAccountState.loading = false;
      }
    };
    const cancel = () => {
      verifyBankAccountState.dialog = false;
      emit("cancel");
      return;
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_label = _resolveComponent("v-label");
      const _component_v_text_field = _resolveComponent("v-text-field");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: verifyBankAccountState.dialog,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => verifyBankAccountState.dialog = $event),
        persistent: "",
        "max-width": "500px"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "text-h5"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("Verify Bank Account", -1)]))]),
            _: 1
          }), _createVNode(_component_v_card_text, {
            class: "mb-4"
          }, {
            default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("div", {
              class: "mb-2"
            }, [_createTextVNode(" You will receive two micro deposits in your ACH account. Once you have received those deposits, you can finalize your ACH account set up by "), _createElementVNode("strong", null, "entering the deposit amounts")], -1)), _createVNode(_component_v_row, {
              justify: "space-between",
              class: "align-center mt-4"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_label, {
                  class: "font-medium text-black"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" First Amount ", -1)]))]),
                  _: 1
                }), _createVNode(_component_v_text_field, {
                  ref_key: "firstAmountInput",
                  ref: firstAmountInput,
                  modelValue: verifyBankAccountState.firstAmount,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => verifyBankAccountState.firstAmount = $event),
                  onInput: _cache[1] || (_cache[1] = event => handleInput(event, 'firstAmount')),
                  type: "text",
                  variant: "outlined",
                  density: "compact",
                  color: "primary"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_label, {
                  class: "font-medium text-black"
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Second Amount ", -1)]))]),
                  _: 1
                }), _createVNode(_component_v_text_field, {
                  modelValue: verifyBankAccountState.secondAmount,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => verifyBankAccountState.secondAmount = $event),
                  onInput: _cache[3] || (_cache[3] = event => handleInput(event, 'secondAmount')),
                  type: "text",
                  variant: "outlined",
                  density: "compact",
                  color: "primary"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_v_card_actions, {
            class: "p-4"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_spacer), _createElementVNode("div", _hoisted_1, [_createVNode(_component_v_card_actions, {
              class: "justify-end"
            }, {
              default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                class: "mr-4",
                onClick: cancel
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("Cancel", -1)]))]),
                _: 1
              }), _createVNode(LlSecondaryButton, {
                color: "primary",
                disabled: isVerifyButtonDisabled.value || verifyBankAccountState.loading,
                onClick: verifyAccount
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(verifyBankAccountState.loading ? "Loading..." : "Verify Account"), 1)]),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};